import getSquareCenter from '%paysera_seat_selection/js/seatSelection/services/getSquareCenter';
import getPolygonPoints from '%paysera_seat_selection/js/seatSelection/services/getPolygonPoints';

function compileGeneralAdmissionPolygon(generalAdmission) {
    const center = getSquareCenter(generalAdmission);
    const points = getPolygonPoints(generalAdmission);

    generalAdmission.compiled = {
        ...generalAdmission.compiled,
        polygon: {
            ...generalAdmission.compiled.polygon,
            center,
            points,
        },
    };

    return generalAdmission;
}

export default compileGeneralAdmissionPolygon;
